<div class="text-center mt-3">
  <h1 class="welcome-heading">Welcome to Park Evaluations</h1>
  <p>Please update your password to complete your registration.</p>
</div>

<div class="alert alert-warning text-center" *ngIf="verifying">
  Verifying link...
</div>

<div class="alert alert-danger text-center" *ngIf="expired === true">
  Your link is expired or invalid.
</div>

<form class="form" #form="ngForm" [hidden]="(verifying || !verifying && expired)">
  <ng-container *ngIf="!mfa.codeSent">
    <div class="form-group">
      <label>Email</label>
      <input type="text" class="form-control" [disabled]="true" [value]="user" />
    </div>
    <div class="form-group">
      <label>Password</label>
      <input
        type="password"
        [(ngModel)]="password"
        [appMinLengthValidator]="6"
        name="password"
        class="form-control"
        required />
      <small id="emailHelp" class="form-text text-muted">Must be at least 6 characters</small>
    </div>
    <div class="form-group">
      <label>Repeat your password</label>
      <input
        type="password"
        [(ngModel)]="passwordRepeat"
        name="passwordRepeat"
        class="form-control"
        [appMinLengthValidator]="6"
        [appEqualToValidator]="password"
        required />
    </div>
  </ng-container>
  <!-- Accounts that already have two-factor authentication must confirm a code before the
       sign-in can complete and the password be set. -->
  <ng-container *ngIf="mfa.codeSent">
    <p>
      Two-factor authentication is enabled on this account. A verification code was sent to
      <strong>{{mfa.phoneHint}}</strong>. Enter it to finish setting your password.
    </p>
    <div class="form-group">
      <label>Verification Code</label>
      <input
        type="text"
        class="form-control ut-signup-mfa-code"
        name="verificationCode"
        autocomplete="one-time-code"
        inputmode="numeric"
        required
        [(ngModel)]="mfa.verificationCode" />
    </div>
  </ng-container>
  <div class="alert alert-danger" *ngIf="error">{{error}}</div>
  <button
    *ngIf="!mfa.codeSent"
    class="btn btn-primary btn-lg btn-block ut-signup-update-btn"
    [disabled]="form.invalid || requestInProgress || !mfa.canSend"
    (click)="update(form)">
    Update
  </button>
  <button
    *ngIf="mfa.codeSent"
    class="btn btn-primary btn-lg btn-block ut-signup-verify-btn"
    [disabled]="form.invalid || requestInProgress || !mfa.codeReady"
    (click)="verifyMfaCodeAndUpdate(); $event.preventDefault()">
    Verify &amp; Update
  </button>
  <button
    *ngIf="mfa.codeSent"
    class="btn btn-link btn-block ut-signup-resend-btn"
    type="button"
    [disabled]="requestInProgress || !mfa.canResend"
    (click)="resendMfaCode()">
    {{mfa.resendLabel}}
  </button>
  <div class="mt-4"></div>
</form>

<div #recaptchaHost></div>
